import { OffersManagementTab } from '../types'
import { Option } from './filters'

export const filterOptions = <T extends string>(
  options: Option<T>[],
  activeTab: OffersManagementTab
): Option<T>[] => {
  return options.filter(item =>
    item.tabs ? item.tabs.includes(activeTab) : true
  )
}
